import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { 
  Bell,
  Search,
  User,
  Settings,
  LogOut,
  Menu,
  X,
  ChevronDown,
  Mail,
  HelpCircle
} from 'lucide-react';
import '../../assets/css/ngodashboard/NgoTopBar.css';
const NgoTopBar = ({ onToggleSidebar, sidebarOpen }) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, title: 'New donation received', time: '5 min ago', unread: true },
    { id: 2, title: 'Request approved', time: '1 hour ago', unread: true },
    { id: 3, title: 'New message from donor', time: '2 hours ago', unread: false }
  ]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.sdms-ngo-notification-dropdown')) {
        setNotificationOpen(false);
      }
      if (!event.target.closest('.sdms-ngo-profile-dropdown')) {
        setProfileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchQuery);
    // Add your search logic here
  };

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <div className="sdms-ngo-topbar">
      <Container fluid>
        <div className="sdms-ngo-topbar-content">
          
          {/* Left Section */}
          <div className="sdms-ngo-topbar-left">
            <button 
              className="sdms-ngo-sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle Sidebar"
            >
              {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            <div className="sdms-ngo-topbar-title">
              <h1>NGO Dashboard</h1>
            </div>
          </div>

          {/* Center Section - Search */}
          <div className={`sdms-ngo-topbar-center ${searchOpen ? 'sdms-search-active' : ''}`}>
            <form className="sdms-ngo-search-form" onSubmit={handleSearch}>
              <Search size={20} className="sdms-search-icon" />
              <input
                type="text"
                placeholder="Search donations, donors, requests..."
                className="sdms-ngo-search-input"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setSearchOpen(true)}
                onBlur={() => setTimeout(() => setSearchOpen(false), 200)}
              />
            </form>
          </div>

          {/* Right Section */}
          <div className="sdms-ngo-topbar-right">
            
            {/* Help Button */}
            <button className="sdms-ngo-icon-btn" title="Help">
              <HelpCircle size={20} />
            </button>

            {/* Notifications */}
            {/* <div className="sdms-ngo-notification-dropdown">
              <button 
                className="sdms-ngo-icon-btn sdms-notification-btn"
                onClick={() => setNotificationOpen(!notificationOpen)}
                title="Notifications"
              >
                <Bell size={20} />
                {unreadCount > 0 && (
                  <span className="sdms-notification-badge">{unreadCount}</span>
                )}
              </button>

              {notificationOpen && (
                <div className="sdms-ngo-dropdown-menu">
                  <div className="sdms-dropdown-header">
                    <h4>Notifications</h4>
                    <button className="sdms-mark-read-btn">Mark all as read</button>
                  </div>
                  <div className="sdms-dropdown-body">
                    {notifications.map(notif => (
                      <div 
                        key={notif.id} 
                        className={`sdms-notification-item ${notif.unread ? 'sdms-unread' : ''}`}
                      >
                        <div className="sdms-notification-content">
                          <p className="sdms-notification-title">{notif.title}</p>
                          <span className="sdms-notification-time">{notif.time}</span>
                        </div>
                        {notif.unread && <span className="sdms-unread-dot"></span>}
                      </div>
                    ))}
                  </div>
                  <div className="sdms-dropdown-footer">
                    <a href="/notifications" className="sdms-view-all-link">View all notifications</a>
                  </div>
                </div>
              )}
            </div> */}

            {/* Profile */}
            <div className="sdms-ngo-profile-dropdown">
              <button 
                className="sdms-ngo-profile-btn"
                
              >
                <div className="sdms-profile-avatar">
                  <User size={18} /> 
                </div>
                 <span className="sdms-profile-name">NGO Admin</span>
                
              </button>

              {profileOpen && (
                <div className="sdms-ngo-dropdown-menu sdms-profile-menu">
                  <div className="sdms-profile-header">
                    <div className="sdms-profile-avatar-large">
                      <User size={24} />
                    </div>
                    <div className="sdms-profile-info">
                      <h4>NGO Admin</h4>
                      <p>admin@ngo.org</p>
                    </div>
                  </div>
                  <div className="sdms-dropdown-divider"></div>
                  <div className="sdms-dropdown-body">
                    <a href="/profile" className="sdms-dropdown-item">
                      <User size={18} />
                      <span>My Profile</span>
                    </a>
                    <a href="/settings" className="sdms-dropdown-item">
                      <Settings size={18} />
                      <span>Settings</span>
                    </a>
                    <a href="/messages" className="sdms-dropdown-item">
                      <Mail size={18} />
                      <span>Messages</span>
                    </a>
                  </div>
                  <div className="sdms-dropdown-divider"></div>
                  <div className="sdms-dropdown-body">
                    <a href="/logout" className="sdms-dropdown-item sdms-logout-item">
                      <LogOut size={18} />
                      <span>Logout</span>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NgoTopBar;